module.exports = __webpack_public_path__ + "static/media/cinco-logo.86d577c4.svg";